import DotRender from '../../components/dotRender'
import IconRender from '../../components/iconRender'
import CircleRender from '../../components/circleRender'
import PinRender from '../../components/pinRender'
import CityBoundary from '../../components/cityBoundary'
import RecommendRender from '../../components/recommendRender'
import SecondActionIcon from '../../components/secondActionIcon'
import EnergyPlans from '../../components/energyPlans'
import RecommendRouteDetail from '../../components/recommendRouteDetail'
import WishRender from '../../components/wishpower/wishRender'
import WishIconRender from '../../components/wishpower/wishIconRender'
import CountyLayout from '../../components/countyLayout'
import CountyLayoutRender from '../../components/countyLayout/countyLayoutRender'
import NewStation from '../../components/newStation'
import NewStationRender from '../../components/newStation/newStationRender'
import Filter from '../../components/filter'
import InteractionBox from '../../components/interactionBox'
import ActionButton from '../../components/actionButton'
import InformationComps from '../../components/informationComps'
import BubbleUp from '../../components/bubbleUp'
import PosterRender from '../../components/posterRender'
export default [
  {
    comp: DotRender,
    props: {
      mapContextRef: true,
      mapInstance: true,
      componentStore: true,
      cdnUrl: true,
    },
  },
  {
    comp: IconRender,
    props: {
      mapContextRef: true,
      mapInstance: true,
      componentStore: true,
    },
  },
  {
    comp: CircleRender,
    props: {
      mapContextRef: true,
      mapInstance: true,
      componentStore: true,
    },
  },
  {
    comp: PinRender,
    props: {
      mapContextRef: true,
      mapInstance: true,
      componentStore: true,
      BMapGL: true,
    },
  },
  {
    comp: CityBoundary,
    props: {
      mapContextRef: true,
      mapInstance: true,
      componentStore: true,
    },
  },
  {
    comp: RecommendRender,
    props: {
      mapContextRef: true,
      mapInstance: true,
      componentStore: true,
      cdnUrl: true,
    },
  },
  {
    // 二级页面操作栏
    comp: SecondActionIcon,
    props: {
      componentStore: true,
    },
  },
  {
    comp: EnergyPlans,
    props: {
      mapContextRef: true,
      mapInstance: true,
      componentStore: true,
    },
  },
  {
    comp: RecommendRouteDetail,
    props: {
      mapContextRef: true,
      mapInstance: true,
      componentStore: true,
    },
  },
  {
    comp: WishRender,
    props: {
      mapContextRef: true,
      mapInstance: true,
      componentStore: true,
      cdnUrl: true,
      settings: true,
    },
  },
  {
    comp: WishIconRender,
    props: {
      mapContextRef: true,
      mapInstance: true,
      componentStore: true,
    },
  },
  {
    comp: NewStation,
    props: {
      mapContextRef: true,
      componentStore: true,
    },
  },
  {
    comp: NewStationRender,
    props: {
      mapContextRef: true,
      mapInstance: true,
      componentStore: true,
    },
  },
  {
    comp: CountyLayout,
    props: {
      mapContextRef: true,
      componentStore: true,
    },
  },
  {
    comp: CountyLayoutRender,
    props: {
      mapContextRef: true,
      mapInstance: true,
      componentStore: true,
      BMapGL: true,
    },
  },
  {
    comp: Filter,
    props: {
      mapContextRef: true,
      mapInstance: true,
      componentStore: true,
    },
  },
  {
    comp: InteractionBox,
    props: {
      componentStore: true,
    },
  },
  {
    comp: ActionButton,
    props: {
      mapContextRef: true,
      mapInstance: true,
      componentStore: true,
      BMapGL: true,
    },
  },
  {
    comp: InformationComps,
    props: {
      componentStore: true,
    },
  },
  {
    comp: BubbleUp,
    props: {
      mapContextRef: true,
      mapInstance: true,
      componentStore: true,
      BMapGL: true,
    },
  },
  {
    comp: PosterRender,
    props: {
      componentStore: true,
    },
  },
]
